/**
 * @generated SignedSource<<7ab4f057f93a55c9eefc9523593d0974>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "StemTransferResponse",
    "kind": "LinkedField",
    "name": "transferAmount",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hash",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WalletTransferMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WalletTransferMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3ece5e5e74a1b3260148d0dcd3c46b88",
    "id": null,
    "metadata": {},
    "name": "WalletTransferMutation",
    "operationKind": "mutation",
    "text": "mutation WalletTransferMutation(\n  $request: TransferRequestInput\n) {\n  transferAmount(request: $request) {\n    hash\n  }\n}\n"
  }
};
})();

node.hash = "9074edf454ecf8e861613415769088da";

module.exports = node;
